import React from "react"
import style from "./VrtGeneralResult.module.sass"


function VrtGeneralResult(props) {
  const {
    colors,
    id,
    time,
    completed, 
    mode                  
  } = props

  return (

        <div className={style.VrtGeneralResult}>
          <div className={style.section}>
            <div className={style.label}>TEMPO</div>
            <div className={style.value}>{time}</div>
          </div>

          <div className={style.section}>
            <div className={style.label}>TASK</div>
            <div className={style.value} style={{ color: colors.primaryColor }}>
              {completed ? "Completato" : "Incompleto"}
            </div>
          </div>

          <div className={style.section}>
            <div className={style.label}>MODALITÀ</div>
            <div className={style.value} style={{ color: colors.primaryColor }}>
              {mode}
            </div>
          </div>

        </div>
   
  )
}

export default VrtGeneralResult